import InnerComponent from '@Components/Inventory/ManageProducts';
import orgContainer from '@Components/AppContainer';

const OrgInventory = () => ((orgContainer(InnerComponent)));
export default OrgInventory;
